import React, { useState } from "react";
import useBatteryPercentage from "../../../customHooks/batteryPercentageProvider";
import { useEffect } from "react";

function BatteryPercentage({ deviceId }) {
  const [batteryPercentage, setBatteryPercentage] = useState(0);
  const { getBatteryPercentageData } =
    useBatteryPercentage(setBatteryPercentage);

  useEffect(() => {
    getBatteryPercentageData(deviceId);
  }, []);

  return (
    <span className="text-small me-2">{`${
      !batteryPercentage ? 0 : batteryPercentage
    }%`}</span>
  );
}

export default BatteryPercentage;
